import { render, staticRenderFns } from "./toolbar-dropdown.vue?vue&type=template&id=f9b1784a&asSrc=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports